"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PureSpinner = function PureSpinner(_ref) {
  var size = _ref.size,
      color = _ref.color,
      margin = _ref.margin,
      padding = _ref.padding,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 6 : _ref$strokeWidth;
  return _react.default.createElement(StyledSpinner, {
    size: size,
    color: color,
    margin: margin,
    padding: padding,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: strokeWidth
  }));
};

var StyledSpinner = _styledComponents.default.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    animation: rotate 1s linear infinite;\n    margin: ", ";\n    padding: ", ";\n    width: ", ";\n    height: ", ";\n  \n    & .path {\n      stroke: ", ";\n      stroke-linecap: round;\n      animation: dash 1.5s ease-in-out infinite;\n    }\n  \n    @keyframes rotate {\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    @keyframes dash {\n      0% {\n        stroke-dasharray: 1, 150;\n        stroke-dashoffset: 0;\n      }\n      50% {\n        stroke-dasharray: 90, 150;\n        stroke-dashoffset: -35;\n      }\n      100% {\n        stroke-dasharray: 90, 150;\n        stroke-dashoffset: -124;\n      }\n    }\n  "])), function (props) {
  return props.margin || '0';
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.size || '50px';
}, function (props) {
  return props.size || '50px';
}, function (props) {
  return props.color ? props.theme.colors[props.color] : props.theme.colors.main;
});

var _default = PureSpinner;
exports.default = _default;